import { NgModule } from '@angular/core';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatIconModule } from '@angular/material/icon';

import { HeaderComponent } from './header/header.component';
import { SharedModule } from '../shared/shared.module';
import { AppRoutingModule } from '../app-routing.module';
import { ErrorPageComponent } from './error-page/error-page.component';
import { AuthService } from '../auth/auth.service';
import { TermsOfUseModule } from '../terms-of-use/terms-of-use.module';
import { ScienceComponent } from './science/science.component';

@NgModule({
  declarations: [
    HeaderComponent,
    ErrorPageComponent,
    ScienceComponent,
  ],
  imports: [
    NgbModule,
    SharedModule,
    AppRoutingModule,
    TermsOfUseModule,
    MatIconModule,
  ],
  exports: [
    AppRoutingModule,
    HeaderComponent
  ],
  providers: [
    AuthService
  ]
})
export class CoreModule {}
